import $ from 'jquery';

$(function () {
  var resizedLogo = function (logo) {
    var $input = $('.js-logo-input');
    return logo.replace($input.data('replaceFrom'), $input.data('replaceTo'));
  };

  var getQueryObject = function ($inputs) {
    var queryParams = new URLSearchParams(window.location.search);

    $inputs.each(function () {
      queryParams.set(this.dataset.emberKeyName, this.value);
    });

    if (queryParams.get('logo')) {
      queryParams.set('logo', resizedLogo(queryParams.get('logo')));
    }

    return queryParams;
  };

  var buildPreviewUrl = function (baseUrl, $inputs, brand) {
    var [originPath, search] = baseUrl.split('?');
    var baseParams = new URLSearchParams(search);
    baseParams.set('brand', brand);

    return (
      originPath +
      '?' +
      baseParams.toString() +
      '&' +
      getQueryObject($inputs).toString()
    );
  };

  if ($('.js-branding-preview-input').length) {
    $('.js-launch-preview-button').click(function () {
      var $form = $(this).parents('.js-company-branding-form');
      var $inputs = $form.find('.js-branding-preview-input');
      var $iframe = $form.find('iframe.js-branding-preview-iframe');
      var $modal = $form.find('.branding-preview-modal');
      var baseUrl = $iframe.data('baseUrl');
      var brand = $(this).data('brand');

      $iframe.attr('src', buildPreviewUrl(baseUrl, $inputs, brand));
      $modal.modal('show');
    });
  }
});
